// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import OverflowPreviewController from "./overflow_preview_controller"
application.register("overflow-preview", OverflowPreviewController)
import QuantityReportController from "./quantity_report_controller"
application.register("quantity-report", QuantityReportController)
import PostingTrackingController from "./posting_tracking_controller"
import PostingLocationController from "./posting_location_controller"
application.register("posting-tracking", PostingTrackingController)
application.register("posting-location", PostingLocationController)

import AuctionModalController from "./auction_modal_controller"
application.register("auction-modal", AuctionModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContactPreferenceController from "./contact_preference_controller"
application.register("contact-preference", ContactPreferenceController)

import CustomerFlowTrackingController from "./customer_flow_tracking_controller"
application.register("customer-flow-tracking", CustomerFlowTrackingController)

import EstimateModalController from "./estimate_modal_controller"
application.register("estimate-modal", EstimateModalController)

import EstimateProgressController from "./estimate_progress_controller"
application.register("estimate-progress", EstimateProgressController)

import FloatingPhoneCtaController from "./floating_phone_cta_controller"
application.register("floating-phone-cta", FloatingPhoneCtaController)

import FormErrorFocusController from "./form_error_focus_controller"
application.register("form-error-focus", FormErrorFocusController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LiffCallbackController from "./liff_callback_controller"
application.register("liff-callback", LiffCallbackController)

import LiffInteractionController from "./liff_interaction_controller"
application.register("liff-interaction", LiffInteractionController)

import LiffPhotoGuideController from "./liff_photo_guide_controller"
application.register("liff-photo-guide", LiffPhotoGuideController)

import LiffSessionController from "./liff_session_controller"
application.register("liff-session", LiffSessionController)

import LiffWindowController from "./liff_window_controller"
application.register("liff-window", LiffWindowController)

import LocationSuggestController from "./location_suggest_controller"
application.register("location-suggest", LocationSuggestController)

import LpEstimateController from "./lp_estimate_controller"
application.register("lp-estimate", LpEstimateController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhotoLibraryCropController from "./photo_library_crop_controller"
application.register("photo-library-crop", PhotoLibraryCropController)

import PurchaseResultsCarouselController from "./purchase_results_carousel_controller"
import PreparationEditorController from "./preparation_editor_controller"
application.register("preparation-editor", PreparationEditorController)

application.register("purchase-results-carousel", PurchaseResultsCarouselController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)
import RowDialogController from "./row_dialog_controller"
application.register("row-dialog", RowDialogController)

import SiteMenuController from "./site_menu_controller"
application.register("site-menu", SiteMenuController)

import VehicleSuggestController from "./vehicle_suggest_controller"
application.register("vehicle-suggest", VehicleSuggestController)

import LineUnavailableController from "./line_unavailable_controller"
application.register("line-unavailable", LineUnavailableController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)
import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DialogCacheController from "./dialog_cache_controller"
application.register("dialog-cache", DialogCacheController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import HistoryTabsController from "./history_tabs_controller"
application.register("history-tabs", HistoryTabsController)

import PostingApplicationController from "./posting_application_controller"
application.register("posting-application", PostingApplicationController)

import NavigationAccordionController from "./navigation_accordion_controller"
application.register("navigation-accordion", NavigationAccordionController)

import OperatorNavigationController from "./operator_navigation_controller"
application.register("operator-navigation", OperatorNavigationController)

import CustomerCompletionController from "./customer_completion_controller"
application.register("customer-completion", CustomerCompletionController)

import DetailsAnimationController from "./details_animation_controller"
application.register("details-animation", DetailsAnimationController)

import OperatorAccountController from "./operator_account_controller"
application.register("operator-account", OperatorAccountController)

import RequestNavigationController from "./request_navigation_controller"
application.register("request-navigation", RequestNavigationController)
import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import LineConversationController from "./line_conversation_controller"
application.register("line-conversation", LineConversationController)

import LineActionsController from "./line_actions_controller"
application.register("line-actions", LineActionsController)
